import FictivSymbol from '~/lib/FictivSymbol'

export const SET_TECHNICAL_DRAWING_SECTION_TYPE = FictivSymbol(
    'SET_TECHNICAL_DRAWING_SECTION_TYPE',
)

export const SET_TECHNICAL_DRAWING_SECTION_ALERT_TYPE = FictivSymbol(
    'SET_TECHNICAL_DRAWING_SECTION_ALERT_TYPE',
)

export const SET_QUOTE_MODEL_REVISIONS = FictivSymbol(
    'SET_QUOTE_MODEL_REVISIONS',
)

export const SET_LOADING_DATA = FictivSymbol('SET_LOADING_DATA')

export const SET_UPLOADING_LOADING_DATA = FictivSymbol(
    'SET_UPLOADING_LOADING_DATA',
)
export const SET_DRAWING_ANALYSIS_INSPECTION = FictivSymbol(
    'SET_DRAWING_ANALYSIS_INSPECTION',
)

export const SET_ANALYZING_DATA = FictivSymbol('SET_ANALYZING_DATA')
export const SET_GENERATED_DRAWING = FictivSymbol('SET_GENERATED_DRAWING')
export const SET_PDFOCR_DATA = FictivSymbol('SET_PDFOCR_DATA')
export const GET_PDFOCR_DATA_FAILURE = FictivSymbol('GET_PDFOCR_DATA_FAILURE')
export const CLEAR_PDFOCR_DATA = FictivSymbol('CLEAR_PDFOCR_DATA')

export const SET_WEBVIEWER_INSTANCE = FictivSymbol('SET_WEBVIEWER_INSTANCE')

export const SET_QUOTE = FictivSymbol('SET_QUOTE')
export const SET_SELECTED_TAB = FictivSymbol('SET_SELECTED_TAB')

export const SET_QMR_HOLE_DETAIL = FictivSymbol('SET_QMR_HOLE_DETAIL')
export const SET_QMR_DFMFEEDBACK_REVISION = FictivSymbol(
    'SET_QMR_DFMFEEDBACK_REVISION',
)
export const SET_EDIT_PDF_MODE = FictivSymbol('SET_EDIT_PDF_MODE')
export const SET_ATTACHMENT_ANNOTATIONS_RESPONSE = FictivSymbol(
    'SET_ATTACHMENT_ANNOTATIONS_RESPONSE',
)
export const SET_SHOW_LOADING = FictivSymbol('SET_SHOW_LOADING')
export const SET_ERROR_MESSAGE = FictivSymbol('SET_ERROR_MESSAGE')
export const SET_SHOW_RFQ_MODAL = FictivSymbol('SET_SHOW_RFQ_MODAL')
export const SET_UN_SAVE_ANNOTATION = FictivSymbol('SET_UN_SAVE_ANNOTATION')
export const SET_PDF_USER_INFO_USERNAME = FictivSymbol(
    'SET_PDF_USER_INFO_USERNAME',
)
export const SET_OBFUSCATEFICTIVANNOTATATIONATTIBUTION = FictivSymbol(
    'SET_OBFUSCATEFICTIVANNOTATATIONATTIBUTION',
)
export const SET_PDF_URL = FictivSymbol('SET_PDF_URL')
export const SET_TECHNICAL_SECTION_BACKGROUD_COLOUR_FOR_WARNING = FictivSymbol(
    'SET_TECHNICAL_SECTION_BACKGROUD_COLOUR_FOR_WARNING',
)

export const SET_ADDITIONAL_REQUIREMENT_ROW_PDFOCR_DATA = FictivSymbol(
    'SET_ADDITIONAL_REQUIREMENT_ROW_PDFOCR_DATA',
)

export const SET_ADDITIONAL_REQUIREMENTS_RAW_PDFOCR_DATA_FAILURE = FictivSymbol(
    'SET_ADDITIONAL_REQUIREMENTS_RAW_PDFOCR_DATA_FAILURE',
)

// page view analytics done through connected-router(which we removed) action
// it's a polyfill to send this action so analytics will work, but instead of connected router we will call it manually from hook useRouterTrack
export const LOCATION_CHANGE = '@@router/LOCATION_CHANGE'
